//REGISTER

export const POST_FAKE_REGISTER = `${process.env.REACT_APP_API_URL}/auth/register`;

//LOGIN
export const POST_FAKE_LOGIN = `${process.env.REACT_APP_API_URL}/auth/login`;
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = `${process.env.REACT_APP_API_URL}/auth/forgot-password`;
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/post-fake-profile";
